import { Card, CardBody, CardHeader, Heading, Stack } from '@chakra-ui/react';
import { useTranslations } from 'use-intl';

import { SubscriptionFundraisingInformations } from './SubscriptionFundraisingInformations';
import { SubscriptionProgression } from './SubscriptionProgression';

type Props = unknown;

export function SubscriptionInformations(): JSX.Element {
  const i18nSubscriptionInformations = useTranslations('SubscriptionInformations');

  return (
    <Card>
      <CardHeader>
        <Heading size="md">{i18nSubscriptionInformations('Title')}</Heading>
      </CardHeader>
      <CardBody>
        <Stack spacing="3">
          <SubscriptionProgression />
          <SubscriptionFundraisingInformations />
        </Stack>
      </CardBody>
    </Card>
  );
}

export type SubscriptionProgressionProps = Props;
